import React from "react";
import { type ApiKey } from "utils/types/api_keys.type";
import { ApiKeyTableRow } from "./ApiKeyTableRow";

interface ApiKeysTableProps {
  apiKeys: ApiKey[] | undefined;
  isLoading: boolean;
  isSuperAdmin: boolean;
  onEdit: (apiKey: ApiKey) => void;
}

export const ApiKeysTable: React.FC<ApiKeysTableProps> = ({
  apiKeys,
  isLoading,
  isSuperAdmin,
  onEdit,
}) => {
  return (
    <div className="bg-white rounded-lg shadow-sm border border-black-800/10 overflow-hidden">
      <div className="table-wrapper max-h-[48rem] overflow-auto">
        <table className="w-full">
          <thead>
            <tr>
              <th className="rounded-l-lg border border-black-800/30 border-r-0 py-5 px-5 text-left">
                Label
              </th>
              <th className="py-5 px-5 border-y border-black-800/30 text-left">
                Key
              </th>
              <th className="py-5 px-5 border-y border-black-800/30 text-left">
                Value
              </th>
              <th className="py-5 px-5 border-y border-black-800/30 text-left">
                Created on
              </th>
              <th className="py-5 px-5 border-y border-black-800/30 text-left">
                Last Updated
              </th>
              {isSuperAdmin && (
                <th className="rounded-r-lg border border-black-800/30 border-l-0 py-5 px-5 text-center">
                  Actions
                </th>
              )}
            </tr>
          </thead>
          <tbody>
            {isLoading && (
              <tr>
                <td
                  colSpan={isSuperAdmin ? 6 : 5}
                  className="text-center py-8"
                >
                  <div className="flex items-center justify-center">
                    <div className="w-6 h-6 rounded-full animate-spin border-2 border-solid border-cyan-800 border-t-transparent"></div>
                    <span className="ml-3 text-black-800">Loading...</span>
                  </div>
                </td>
              </tr>
            )}
            {!isLoading && apiKeys && apiKeys.length === 0 && (
              <tr>
                <td
                  colSpan={isSuperAdmin ? 6 : 5}
                  className="text-center py-8"
                >
                  <div className="flex flex-col items-center justify-center">
                    <p className="text-black-800 text-sm opacity-70">
                      No API keys found
                    </p>
                  </div>
                </td>
              </tr>
            )}
            {!isLoading &&
              apiKeys &&
              apiKeys.map((apiKey) => (
                <ApiKeyTableRow
                  key={apiKey.id}
                  apiKey={apiKey}
                  isSuperAdmin={isSuperAdmin}
                  onEdit={() => onEdit(apiKey)}
                />
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

